/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_TitleInputs */

const en_mk_price_title = /** @type {(inputs: Mk_Price_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free. Grow at your own pace.`)
};

const id_mk_price_title = /** @type {(inputs: Mk_Price_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai gratis. Pilih paket saat kebutuhan tumbuh.`)
};

/**
* | output |
* | --- |
* | "Start free. Grow at your own pace." |
*
* @param {Mk_Price_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_title = /** @type {((inputs?: Mk_Price_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_title(inputs)
	return en_mk_price_title(inputs)
});